import {css} from '../theme/css'

export const classes = {
  checkbox: css`
    -webkit-tap-highlight-color: transparent;

    &::after {
      border-radius: inherit;
    }
  `,
  checkboxError: css`
    background-color: var(--components-checkboxes-hoveredColor) !important;

    &::after {
      opacity: 1;
      border: 2px solid var(--colorScheme-error);
    }
  `,
  label: css`
    cursor: pointer;
  `,
}
